<!-- eslint-disable vue/multi-word-component-names -->
<template>
    <div class="footer">
        <div class="llayout-main">
            <footer class="hf-footer">
                <div class="e-con-inner">
                    <div class="down-box">
                        <div class="logo-box">
                            <img class="logo-img" src="@/assets/home/logo.png" alt="logo-ff-white" />
                            <!-- <div class="footer-app-box">
                                <div class="footer-app-inner apple">
                                    <img src="https://forexforest.com/wp-content/uploads/2023/10/apple.png" alt="apple-icon" />
                                    <div class="footer-app-content">
                                        <span>Download on the</span>
                                        <p class="mb-0">App Store</p>
                                    </div>
                                </div>
                                <div class="footer-app-inner google">
                                    <img src="https://forexforest.com/wp-content/uploads/2023/10/play.png" alt="playstore-icon" />
                                    <div class="footer-app-content">
                                        <span>GET IT ON</span>
                                        <p class="mb-0">Google Play</p>
                                    </div>
                                </div>
                            </div> -->
                        </div>
                    </div>
                    <img
                        src="@/assets/home/footer.png"
                        class="atta-img"
                        alt=""
                    />
                    <div class="tips-box">
                        <p class="tips">
                            {{ $t('about.desp12') }}
                        </p>
                    </div>
                    <div class="info-box">
                        <div class="info">
                            <a href="javascript:;" target="_blank">{{ $t('about.desp13') }}</a>｜<a href="javascript:;" target="_blank">{{ $t('about.desp14') }}</a>｜© 2025 All
                            Rights Reserved By Forex Forest (Algo Forest Group)
                        </div>
                        <div class="social-list">
                            <a href="https://www.facebook.com/forexforesthk" class="social" target="_blank">
                                <img src="@/assets/footer/facebook.svg" alt="" />
                            </a>
                            <a href="https://www.instagram.com/forexforestofficial/" class="social" target="_blank">
                                <img src="@/assets/footer/instagram.svg" alt="" />
                            </a>
                            <a href="https://www.linkedin.com/company/forexforest/posts/?feedView=all" class="social" target="_blank">
                                <img src="@/assets/footer/linkedin.svg" alt="" />
                            </a>
                            <a href="https://www.youtube.com/@ForexForest" class="social" target="_blank">
                                <img src="@/assets/footer/youtube.svg" alt="" />
                            </a>
                        </div>
                    </div>
                    <img width="81" height="40" src="https://forexforest.com/wp-content/uploads/2023/10/footer_shape.png" class="trend-line" alt="" />
                </div>
            </footer>
        </div>
    </div>
</template>

<script>
export default {}
</script>

<style lang="less" scoped>
.footer {
    background-color: #09093f;
}
.hf-footer {
    display: flex;
    flex-direction: column;
    font-size: 14px;
    overflow: hidden;
    padding-bottom: 60px;
    position: relative;
    .down-box {
        display: flex;
        flex-direction: row;
        width: initial;
        height: 100%;
        flex-grow: 1;
        align-self: stretch;
        gap: 40px 25px;
        row-gap: 40px;
        column-gap: 25px;
        padding-top: 80px;
        padding-bottom: 50px;
        padding-left: 0px;
        padding-right: 0px;
    }
}
.llayout-main {
    flex: 1 1;
    padding-left: calc(50% - 120px / 2 - 490px);
    padding-right: calc(50% - 120px / 2 - 600px);
    width: calc(100% - 120px);
}
.logo-img {
    width: 183px;
    margin-bottom: 20px;
}
.footer-app-inner {
    background-color: #00d094;
    color: #0c263a;
    border-radius: 8px;
    display: flex;
    align-items: center;
    padding: 5px 10px;
    margin-right: 12px;
    .footer-app-content {
        margin-left: 8px;
    }
    span {
        font-size: 0.5rem;
        line-height: 1;
    }
    p {
        font-size: 0.875rem;
        line-height: 1;
    }
}
.footer-app-box {
    display: flex;
}
.google {
    background-color: #124d6d;
}
.tips-box {
    padding: 25px 0;
    border-top: 1px solid #ffffff1a;
    border-bottom: 1px solid #ffffff1a;
    .tips {
        font-family: 'Open Sans', HK;
        font-size: 1rem;
        line-height: 1.625em;
        -webkit-text-stroke-color: #000;
        stroke: #000;
        color: #ffffff;
    }
}
.info-box {
    padding: 25px 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .info {
        font-family: 'Open Sans', HK;
        font-size: 1rem;
        line-height: 1.625em;
        -webkit-text-stroke-color: #000;
        stroke: #000;
        color: #ffffff;
    }
}
.social-list {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    .social {
        border-radius: 99px;
        border: 2px solid rgba(255, 255, 255, 0.1);
        width: 40px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-left: 10px;
    }
    img {
        width: 18px;
        height: 18px;
    }
}
.trend-line {
    position: absolute;
    top: 12%;
    left: 33%;
}
.atta-img {
    width: 70%;
    height: auto;
}
@media screen and (max-width: 1440px) {
    .llayout-main {
        padding-left: 150px;
        padding-right: 40px;
        width: 100%;
    }
}
@media screen and (max-width: 768px) {
    .llayout-main {
        padding-left: 15px;
        padding-right: 15px;
    }
    .trend-line {
        position: absolute;
        top: 12%;
        left: 60%;
    }
    .hf-footer {
        padding-bottom: 0;
        .down-box {
            padding-top: 80px;
            padding-bottom: 80px;
        }
    }
    .logo-img {
        margin-bottom: 80px;
    }
    .info-box {
        flex-direction: column;
        .info {
            margin-bottom: 25px;
        }
    }
}
</style>
